"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderService = void 0;
var constants_1 = require("../constants");
var client_1 = require("../models/client");
var exceptions_1 = require("../models/api/exceptions");
var axios_1 = require("axios");
var index_1 = require("./index");
function getOrders(query) {
    var _this = this;
    var CancelToken = axios_1.default.CancelToken;
    // create the source
    var source = CancelToken.source();
    var getOrdersPromise = axios_1.default.get(constants_1.API_BASE_URL + "/orders", {
        params: query,
        cancelToken: source.token,
    });
    var promise = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, index_1.csrfService.getCookie()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, getOrdersPromise];
                case 2:
                    response = _a.sent();
                    resolve(__assign(__assign({}, response.data), { data: response.data.data.map(function (order) { return new client_1.OrderClientModel(order); }) }));
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    reject(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); });
    promise.cancel = function () { return source.cancel(); };
    return promise;
}
function getOrderById(id) {
    return __awaiter(this, void 0, void 0, function () {
        var response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, index_1.csrfService.getCookie()];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, getOrders({ id: id })];
                case 2:
                    response = _b.sent();
                    return [2 /*return*/, response.data[0]];
                case 3:
                    _a = _b.sent();
                    throw new exceptions_1.OrderNotFoundException();
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getReprintXqcOrder(query) {
    var _this = this;
    var CancelToken = axios_1.default.CancelToken;
    // create the source
    var source = CancelToken.source();
    var getOrdersPromise = axios_1.default.get(constants_1.API_BASE_URL + "/orders/get-reprint-xqc-order", {
        params: query,
        cancelToken: source.token,
    });
    var promise = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, index_1.csrfService.getCookie()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, getOrdersPromise];
                case 2:
                    response = _a.sent();
                    resolve(__assign(__assign({}, response), { data: response.data.data.map(function (order) { return new client_1.OrderClientModel(order); }) }));
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    reject(error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); });
    promise.cancel = function () { return source.cancel(); };
    return promise;
}
function getOrderCountList() {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, index_1.csrfService.getCookie()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, axios_1.default.get(constants_1.API_BASE_URL + "/get-order-status")];
                case 2:
                    response = _a.sent();
                    // Return after mapping to client model
                    return [2 /*return*/, new client_1.OrderCountListClientModel(response.data)];
            }
        });
    });
}
function updateOrderQueueStatus(orderRef, status) {
    return __awaiter(this, void 0, void 0, function () {
        var body;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = status ? { status: status } : {};
                    return [4 /*yield*/, index_1.csrfService.getCookie()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, axios_1.default.post(constants_1.API_BASE_URL + "/orders/update/" + orderRef, body).then(function (response) { return response.data; })];
            }
        });
    });
}
exports.orderService = {
    getOrders: getOrders,
    getOrderById: getOrderById,
    getOrderCountList: getOrderCountList,
    updateOrderQueueStatus: updateOrderQueueStatus,
    getReprintXqcOrder: getReprintXqcOrder,
};
